import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { graphql, useStaticQuery } from "gatsby"

// Import data from components/MembersFee from Google Docs.
const MembersFee = () => {
  const { swishImage } = useStaticQuery(graphql`
    {
      swishImage: file(name: { eq: "members-fee-swish" }) {
        childImageSharp {
          gatsbyImageData(height: 200, quality: 80)
        }
      }
    }
  `)

  return (
    <div className="members-fee">
      <div className="members-fee__column1">
        <h2>Medlemsavgift för Equmenia Örbyhus</h2>
        <p>Medlemsavgiften är för närvarande 150 kr/termin.</p>
        <p>
          Medlemsavgiften betalas in till Equmenia Örbyhus bankgiro: 5427-8650,
          märk inbetalningen med ”Namn + Personnummer (10 siffror)”.
        </p>
        <p>
          Du kan också swisha in medlemsavgiften till swishnummer: 123 390 81 00
        </p>
        <p>
          Medlemsavgiften hjälper till att bekosta verksamheten som vi bedriver
          i Equmenia Örbyhus. Du betalar en medlemsavgift oavsett hur många
          verksamhetsgrupper du finns med i.
        </p>
        <p>
          Alla deltagare är försäkrad under våra aktiviteter, samt till och från
          dessa. Mer info om försäkringen finns på{" "}
          <a href="https://equmenia.se/forening/forsakring/">equmenia.se</a>.
        </p>
      </div>
      <div className="members-fee__column2">
        <GatsbyImage
          image={swishImage.childImageSharp.gatsbyImageData}
          alt="Swish QR"
        />
      </div>
    </div>
  )
}

export default MembersFee
